import {request} from '@/sealFilter/request'

// 管理后台的订单
export function listManagerOrders (param = {}) {
    return request({
        url: '/order/action/listManagerOrders',
        method: 'post',
        data: param
    })
}
// 批量导出订单
export function bachExportOrder (param = {}) {
    return request({
        url: '/order/action/exportOrderByQuery',
        method: 'post',
        data: param
    })
}



// WEBPACK FOOTER //
// ./src/api/manager.js